import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import DemographicsSinglePersonaHeaderInfo from './DemographicsSinglePersonaHeaderInfo';
import DemographicDoubleComparisionHeaderInfo from './DemographicDoubleComparisionHeaderInfo';
import DemographicTripleComparisionHeaderInfo from './DemographicTripleComparisionHeaderInfo';
import * as insight360Actions from '../../../actions/insight360Actions';
import * as definitionActions from '../../../actions/definitionActions';
import {
  PERSONA_CREATOR_DEF_LENGTH,
} from '../../../constants';
import {
  PERSONA_CREATOR_DEF_LENGTH_WARNING,
  DUPLICATE_DEFINITION_WARNING,
} from '../../../messages/messages';
import PercentageFilterSlider from '../PercentageFilterSlider';
import Modal from '../../common/Modal/Modal';
import SaveDefinitionLabelPopupScreen from '../../common/SaveDefinitionLabelPopupScreen';

const modalSettingStyle = {
  width: '51%',
  height: '40px',
  left: '24%',
  top: '20%',
};

class PersonaHeader extends Component {
  constructor(props) {
    super(props);
    /* const percentageParametersPdfFlag = false; */
    this.state = {
      insight360PersonaPct: this.props.pct !== undefined ? this.props.pct : [],
      insight360PersonaWeighted:
        this.props.weight !== undefined ? this.props.weight : [],
      insight360PersonaSample:
        this.props.sample !== undefined ? this.props.sample : [],
      insight360PersonaExpression:
        this.props.expression !== undefined ? this.props.expression : [],
      insight360PersonaLabel:
        this.props.label !== undefined ? this.props.label : [],
      personaFilter: [],
      isReports:
        this.props.isReports !== undefined ? this.props.isReports : false,
      personaHeaderLabelUpdateObject: {},
      personaHeaderLabelUpdateCallBack: '',
      index: null,
      popupCloseButtonClick: true,
    };
  }

  /* componentDidMount() {
     this.props.getDefinationdata();
   } */

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.expression !== undefined) {
      this.setState({ insight360PersonaExpression: nextProps.expression });
    }

    if (nextProps.label !== undefined) {
      this.setState({ insight360PersonaLabel: nextProps.label });
    }

    if (nextProps.pct !== undefined && this.props.pct !== nextProps.pct) {
      this.setState({ insight360PersonaPct: nextProps.pct });
    }

    if (
      nextProps.weight !== undefined &&
      this.props.weight !== nextProps.weight
    ) {
      this.setState({ insight360PersonaWeighted: nextProps.weight });
    }

    if (
      nextProps.sample !== undefined &&
      this.props.sample !== nextProps.sample
    ) {
      this.setState({ insight360PersonaSample: nextProps.sample });
    }

    if (nextProps.personaFilter !== undefined) {
      this.setState(
        { personaFilter: nextProps.personaFilter },
        this.forceUpdate(),
      );
    }
  }

  personaHeaderLabelUpdate = (value, callback, index) => {
    const copyInsight360PersonaLabel = _.clone(this.state.insight360PersonaLabel);
    const expression = [];
    let definationId = null;

    copyInsight360PersonaLabel.forEach((label, key) => {
      const personaDefId = _.clone(this.props.personaDefId);
      if (key === index) {
        const expressionObj = {
          id:
            typeof this.props.personaExpressionID[key] !== 'undefined'
              ? this.props.personaExpressionID[key]
              : null,
          title: value.trimStart(),
          expression: this.state.insight360PersonaExpression[key],
        };
        expression.push(expressionObj);
        definationId = personaDefId[key];
      }
    });

    const labelUpdateData = {
      defId: definationId,
      defName: '',
      expressions: expression,
    };
    this.setState({
      personaHeaderLabelUpdateObject: labelUpdateData,
      personaHeaderLabelUpdateCallBack: callback,
      index,
    });

    this.confirmationModal.show();
    // this.props.saveUpdatedDefinitionData(labelUpdateData, callback, index);
  };

  personaHeaderLabelValidate = (value, callback) => {
    // check the label max length equal to 64
    const callBackArg = value.length < PERSONA_CREATOR_DEF_LENGTH;
    if (callBackArg) {
      const findIndex = this.state.insight360PersonaExpression.findIndex(
        expression => (expression === value)
      );
      if (findIndex === -1) {
        callback(true);
      } else {
        callback(false, DUPLICATE_DEFINITION_WARNING);
      }
    } else {
      callback(false, PERSONA_CREATOR_DEF_LENGTH_WARNING);
    }
  };

  onPersonaHeaderLabelSave = definationObject => {
    const personaHeaderLabelUpdateObject = _.clone(
      this.state.personaHeaderLabelUpdateObject,
    );

    if (
      definationObject.definitionFolderId !==
      personaHeaderLabelUpdateObject.defId
    ) {
      personaHeaderLabelUpdateObject.defId =
        definationObject.definitionFolderId;
      personaHeaderLabelUpdateObject.expressions[0].id = null;
    }
    personaHeaderLabelUpdateObject.defName =
      definationObject.definitionFolderName;

    this.props.saveUpdatedDefinitionData(
      personaHeaderLabelUpdateObject,
      this.state.personaHeaderLabelUpdateCallBack,
      this.state.index,
    );
    this.setState(
      {
        popupCloseButtonClick: false,
      },
      () => {
        this.confirmationModal.hide();
      },
    );
  };

  onModalPopupXButtonClick = () => {
    if (this.state.popupCloseButtonClick) {
      this.state.personaHeaderLabelUpdateCallBack(false);
    } else {
      this.setState({
        popupCloseButtonClick: true,
      });
    }
  };

  render() {
    return (
      <div className="row expanded header-margin" id="personaHeader">
        <Modal
          title=""
          ref={node => (this.confirmationModal = node)}
          dialogStyles={modalSettingStyle}
          afterClose={this.onModalPopupXButtonClick}
        >
          <div className="text-center">
            <div className="">
              <SaveDefinitionLabelPopupScreen
                definitionTree={this.props.definitionTree}
                personaHeaderLabelUpdateObject={
                  this.state.personaHeaderLabelUpdateObject
                }
                onPersonaHeaderLabelSave={this.onPersonaHeaderLabelSave}
                productNo={this.props.productNo}
              />
            </div>
          </div>
        </Modal>
        <div className="pdfSinglePersonaHeader">
          {this.state.insight360PersonaExpression !== undefined &&
            this.state.insight360PersonaExpression.length === 1 &&
            this.props.filterOptions !== undefined && (
            <DemographicsSinglePersonaHeaderInfo
              expression={this.state.insight360PersonaExpression[0]}
              label={this.state.insight360PersonaLabel[0]}
              pct={this.state.insight360PersonaPct[0]}
              weight={this.state.insight360PersonaWeighted[0]}
              sample={this.state.insight360PersonaSample[0]}
              filterOptions={this.props.filterOptions}
              filterExpressionChanged={this.props.filterExpressionChanged}
              index={0}
              removeDemographic={this.props.removeDemographic}
              personaFilter={this.state.personaFilter}
              isReports={this.state.isReports}
              personaHeaderLabelUpdate={this.personaHeaderLabelUpdate}
              personaHeaderLabelValidate={this.personaHeaderLabelValidate}
              trackerFn={this.props.trackerFn}
            />
            )}
          {this.state.insight360PersonaExpression !== undefined &&
            this.state.insight360PersonaExpression.length === 2 && (
            <div className="row fullwidth">
              <div className="row fullwidth demographic-detail-columns pdfDoublePersonaHeader">
                {!_.isEmpty(this.state.insight360PersonaExpression) &&
                  this.state.insight360PersonaExpression.length > 0 &&
                  this.state.insight360PersonaExpression.map(
                    (expr, index) => (
                      <div key={`head-d${index}`}>
                        <div className="columns large-6 medium-6 small-6 pdfHeaderDoublePersonaBorder">
                          <div
                            className={`row fullwidth demographic-header-border demographic-detail-columns relative-position ${
                              index === 1 ? '' : 'header-margin-right'
                            }`}
                          >
                            <div className="columns large-12 medium-12 small-12">
                              <DemographicDoubleComparisionHeaderInfo
                                expression={expr}
                                label={
                                  this.state.insight360PersonaLabel[index]
                                }
                                pct={this.state.insight360PersonaPct[index]}
                                weight={
                                  this.state.insight360PersonaWeighted[
                                    index
                                  ]
                                }
                                sample={
                                  this.state.insight360PersonaSample[index]
                                }
                                filterOptions={this.props.filterOptions}
                                filterExpressionChanged={
                                  this.props.filterExpressionChanged
                                }
                                index={index}
                                removeDemographic={
                                  this.props.removeDemographic
                                }
                                key={index}
                                personaFilter={this.state.personaFilter}
                                personaHeaderLabelUpdate={
                                  this.personaHeaderLabelUpdate
                                }
                                personaHeaderLabelValidate={
                                  this.personaHeaderLabelValidate
                                }
                                trackerFn={this.props.trackerFn}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
              </div>
            </div>
          )}
          {this.state.insight360PersonaExpression !== undefined &&
            this.state.insight360PersonaExpression.length === 3 && (
            <div className="triple-persona-header-margin">
              <div className="row fullwidth demographic-detail-columns pdfTriplePersonaHeader">
                {!_.isEmpty(this.state.insight360PersonaExpression) &&
                  this.state.insight360PersonaExpression.length > 0 &&
                  this.state.insight360PersonaExpression.map(
                    (expr, index) => (
                      <div key={`head-t${index}`}>
                        <div className="columns large-4 medium-4 small-4 pdfTriplePersonaBorder">
                          <div
                            className={`row fullwidth demographic-header-border demographic-detail-columns ${
                              index === 0 ? 'triple-header-margin-left' : ''
                            } ${index === 2 ? '' : 'header-margin-right'}`}
                          >
                            <div className="columns large-12 medium-12 small-12 relative-position">
                              <DemographicTripleComparisionHeaderInfo
                                expression={expr}
                                label={
                                  this.state.insight360PersonaLabel[index]
                                }
                                pct={this.state.insight360PersonaPct[index]}
                                weight={
                                  this.state.insight360PersonaWeighted[
                                    index
                                  ]
                                }
                                sample={
                                  this.state.insight360PersonaSample[index]
                                }
                                filterOptions={this.props.filterOptions}
                                filterExpressionChanged={
                                  this.props.filterExpressionChanged
                                }
                                index={index}
                                removeDemographic={
                                  this.props.removeDemographic
                                }
                                key={index}
                                personaFilter={this.state.personaFilter}
                                personaHeaderLabelUpdate={
                                  this.personaHeaderLabelUpdate
                                }
                                personaHeaderLabelValidate={
                                  this.personaHeaderLabelValidate
                                }
                                trackerFn={this.props.trackerFn}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
              </div>
            </div>
          )}
        </div>
        <div id="percentageFilterPdf">&nbsp;
          {/* {this.state.insight360PersonaExpression !== undefined &&
            this.state.insight360PersonaExpression.length > 0 && (
            <PercentageFilterSlider
              value={this.props.vpct}
              applyVpctFilter={this.props.applyVpctFilter}
            />
            )} */}
        </div>
        {this.percentageParametersPdfFlag === true &&
          (this.state.insight360PersonaExpression !== undefined &&
            this.state.insight360PersonaExpression.length > 0) && (
          <div className="row expanded" id="percentageBarPdfBlock">
            Percentage Parameters:{this.props.vpct}%
          </div>
          )}
      </div>
    );
  }
}

PersonaHeader.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  filterOptions: PropTypes.shape({}),
  filterExpressionChanged: PropTypes.func,
  removeDemographic: PropTypes.func,
  // personaFilter: PropTypes.arrayOf(PropTypes.string),
  expression: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.arrayOf(PropTypes.string),
  pct: PropTypes.arrayOf(PropTypes.number),
  weight: PropTypes.arrayOf(PropTypes.number),
  sample: PropTypes.arrayOf(PropTypes.number),
  isReports: PropTypes.bool,
  applyVpctFilter: PropTypes.func,
  vpct: PropTypes.number,
  // updateLoadedData: PropTypes.func,
  trackerFn: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    demographics: state.insight360.demographics,
    filterOptions: state.insight360.insight360DemographicsFilterOptions,
    expression: state.insight360.insight360PersonaExpression,
    label: state.insight360.insight360PersonaLabel,
    pct: state.insight360.insight360PersonaPct,
    weight: state.insight360.insight360PersonaWeighted,
    sample: state.insight360.insight360PersonaSample,
    vpct: state.insight360.inight360VerticalPercent,
    smartSearchStudy: state.study.insight360study,
    productNo: state.study.insight360study.pn,
    studySource: state.study.insight360study.ss,
    personaDefId: state.insight360.insight360ExplorerDefId,
    personaExpressionID: state.insight360.insight360PersonaExpressionID,
    definitionTree:
      typeof state.definition.definitionTree !== 'undefined' &&
      typeof state.definition.definitionTree.data !== 'undefined'
        ? state.definition.definitionTree.data
        : [],
  };
}

/* function mapDispatchToProps(dispatch) {
  return {
    // brand360Actions: bindActionCreators(brand360Actions, dispatch),
  };
} */

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const refreshDefinationdata = () => {
    dispatch(
      definitionActions.getDefinitionTreeLoad(
        stateProps.loginResponse.data.token,
        stateProps.studySource === 'SIMMONS' ? 1 : 2,
        stateProps.activeAccountId,
        stateProps.productNo,
      ),
    );
  };

  const saveUpdatedDefinitionData = (updatedlabelData, callbackFn, index) => {
    dispatch(
      insight360Actions.saveDefinitionData(
        stateProps.loginResponse.data.token,
        stateProps.loginResponse.data.uid,
        stateProps.activeAccountId,
        stateProps.productNo,
        updatedlabelData,
        callbackFn,
        refreshDefinationdata,
        index,
      ),
    );
  };

  return { ...stateProps, ...ownProps, saveUpdatedDefinitionData, };
};

export default connect(
  mapStateToProps,
  null,
  mergeProps,
  { forwardRef: true },
)(PersonaHeader);
